
import {
  computed,
  defineComponent,
  onMounted,
  onUpdated,
  reactive,
  ref,
} from "vue";
import { hideModal } from "@/core/helpers/dom";
import { StepperComponent } from "@/assets/ts/components/_StepperComponent";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import Datepicker from "vue3-date-time-picker";
import "vue3-date-time-picker/dist/main.css";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { useRouter } from "vue-router";
import { useForm } from "vee-validate";
import useSegip from "@/filiation/composables/useFiliation";
import countries from "@/core/data/countries";
import languages from "@/core/data/languages";
import jobs from "@/core/data/jobs";
import original_identity from "@/core/data/original_identity";
import personImg from "@/assets/person.png";
interface Step1 {
  tipo_documento: string;
  numero_doc: string;
  complemento: string;
  nombres: string;
  primerApellido: string;
  segundoApellido: string;
  fechaNacimiento: string;
  lugarNacimientoPais: string;
  lugarNacimientoDepartamento: string;
  lugarNacimientoProvincia: string;
  lugarNacimientoLocalidad: string;
  fotografia: string;
  domicilio: string;
  genero: string;
  telefono: string;
  grado_instruccion: string;
  idioma: string;
  idioma1: string;
  oficio_profesion: string;
  religion: string;
  id_etnica: string;
  estado_civil: string;
  id_sexual: string;
}

interface Step2 {
  numeroFile: string;
  jurisdiccion: string;
  juez: string;
  juzgado: string;
  centro_penitenciario: string;
  descripcion_codigo: string;
  codigo: string;
  situacion_juridica: string;
  delito: string;
  anios_sentencia: string;
  meses_sentencia: string;
  fechaIngreso: string;
  observaciones: string;
}

interface Step3 {
  enfermedad: string;
  medicacion: boolean;
  descripcionMedicacion: string;
  obsEnfermedades: string;
}

interface Step4 {
  nombreFamiliar: string;
  parentesco: string;
  telefonoFamiliar: number;
  nombreFamiliar1: string;
  parentesco1: string;
  telefonoFamiliar1: number;
}

//interface KTCreateApp extends Step1, Step2, Step3, Step4 {}

export default defineComponent({
  name: "filiation-modal",
  components: {
    Datepicker,
    vSelect,
  },
  setup(props, context) {
    const router = useRouter();
    const _stepperObj = ref<StepperComponent | null>(null);
    const createAccountRef = ref<HTMLElement | null>(null);
    const createAccountModalRef = ref<HTMLElement | null>(null);
    const currentStepIndex = ref(0);
    const centersList = ref([]);
    const departamentsList = ref([]);
    const provincesList = ref([]);
    const municipalitiesList = ref([]);
    const crimesList = ref([]);
    const isLoading = ref(false);
    const haveData = ref(false);
    const actualYear = ref(new Date());
    const actualAge = ref("");
    const formData = ref({
      tipo_documento: "",
      numero_doc: "",
      complemento: "",
      nombres: "",
      primerApellido: "",
      segundoApellido: "",
      fechaNacimiento: "",
      lugarNacimientoPais: "",
      lugarNacimientoDepartamento: "",
      lugarNacimientoProvincia: "",
      lugarNacimientoLocalidad: "",
      fotografia: "",
      domicilio: "",
      genero: "",
      telefono: "",
      grado_instruccion: "",
      idioma: "",
      idioma1: "",
      oficio_profesion: "",
      religion: "",
      id_etnica: "",
      estado_civil: "",
      id_sexual: "",
      numeroFile: "",
      jurisdiccion: "",
      juez: "",
      juzgado: "",
      centro_penitenciario: "",
      descripcion_codigo: "",
      codigo: "",
      situacion_juridica: "",
      delito: [],
      anios_sentencia: "",
      meses_sentencia: "",
      fechaIngreso: "",
      observaciones: "",
      enfermedad: "",
      enfermedad1: "",
      medicacion: false,
      descripcionMedicacion: "",
      descripcionMedicacion1: "",
      obsEnfermedades: "",
      nombreFamiliar: "",
      parentesco: "",
      telefonoFamiliar: "",
      nombreFamiliar1: "",
      parentesco1: "",
      telefonoFamiliar1: "",
    });

    const {
      searchSegip,
      namePenitenciariesCenters,
      nameDepartaments,
      nameProvinces,
      nameMunicipalities,
      nameCrimes,
      getDataByIds,
      sendForm,
      dataToEdit,
      resetStatus,
    } = useSegip();
    const birthDate = (date) => {
      if (date !== undefined) {
        let format = date.split("/");
        let lastFormat = format[1] + "-" + format[0] + "-" + format[2];
        return lastFormat;
      }
      return "";
    };
    const age = (date2) => {
      let date1 = new Date();
      const years = date1.getFullYear() - date2.getFullYear();
      return (actualAge.value = years + " años \n");
    };
    const format = (date) => {
      const day = date.getDate();
      let month = date.getMonth();
      switch (month) {
        case 0:
          month = "Ene";
          break;
        case 1:
          month = "Feb";
          break;
        case 2:
          month = "Mar";
          break;
        case 3:
          month = "Abr";
          break;
        case 4:
          month = "May";
          break;
        case 5:
          month = "Jun";
          break;
        case 6:
          month = "jul";
          break;
        case 7:
          month = "Ago";
          break;
        case 8:
          month = "Sept";
          break;
        case 9:
          month = "Oct";
          break;
        case 10:
          month = "Nov";
          break;
        case 11:
          month = "Dic";
      }
      const year = date.getFullYear();
      return `${day} ${month} de ${year}`;
    };
    const resetformData = () => {
      const v = formData.value;
      v.tipo_documento = "";
      v.numero_doc = "";
      v.complemento = "";
      v.nombres = "";
      v.primerApellido = "";
      v.segundoApellido = "";
      v.fechaNacimiento = "";
      v.lugarNacimientoPais = "BOLIVIA";
      v.lugarNacimientoDepartamento = "";
      v.lugarNacimientoProvincia = "";
      v.lugarNacimientoLocalidad = "";
      v.fotografia = "";
      v.domicilio = "";
      v.genero = "";
      v.telefono = "";
      v.grado_instruccion = "";
      v.idioma = "";
      v.idioma1 = "";
      v.oficio_profesion = "";
      v.religion = "";
      v.id_etnica = "";
      v.estado_civil = "";
      v.id_sexual = "";
      v.numeroFile = "";
      v.jurisdiccion = "";
      v.juez = "";
      v.juzgado = "";
      v.centro_penitenciario = "";
      v.descripcion_codigo = "";
      v.codigo = "";
      v.situacion_juridica = "";
      v.delito = [];
      v.anios_sentencia = "";
      v.meses_sentencia = "";
      v.fechaIngreso = "";
      v.observaciones = "";
      v.enfermedad = "";
      v.enfermedad1 = "";
      v.medicacion = false;
      v.descripcionMedicacion = "";
      v.descripcionMedicacion1 = "";
      v.obsEnfermedades = "";
      v.nombreFamiliar = "";
      v.parentesco = "";
      v.telefonoFamiliar = "";
      v.nombreFamiliar1 = "";
      v.parentesco1 = "";
      v.telefonoFamiliar1 = "";
      actualAge.value = "";
      haveData.value = false;
    };
    const nameCenters = async () => {
      const { data } = await namePenitenciariesCenters();
      centersList.value = data;
    };
    const nameDepartament = async () => {
      const { data } = await nameDepartaments();
      departamentsList.value = data;
    };
    const nameProvince = async (id) => {
      const { data } = await nameProvinces(id);
      provincesList.value = data;
    };
    const nameMunicipality = async (prov) => {
      const dep = formData.value.lugarNacimientoDepartamento;
      const d = { dep, prov };
      const { data } = await nameMunicipalities(d);
      municipalitiesList.value = data;
    };
    const nameCrime = async () => {
      const { data } = await nameCrimes();
      crimesList.value = data;
    };
    // const { data, delito } = dataToEdit.value.data;
    // console.log(data);
    // const v = formData.value;
    // v.tipo_documento = data.tipo_documento;
    // v.numero_doc = data.nro_documento;
    // v.complemento = data.complemento;
    // v.nombres = data.nombres;
    // v.primerApellido = data.primer_apellido;
    // v.segundoApellido = data.segundo_apellido;
    // v.fechaNacimiento = data.fecha_nacimiento;
    // v.lugarNacimientoPais = data.pais;
    // v.lugarNacimientoDepartamento = data.departamento;
    // v.lugarNacimientoProvincia = data.provincia;
    // v.lugarNacimientoLocalidad = data.localidad;
    // v.fotografia = data.imagen_segip;
    // v.domicilio = data.direccion;
    // v.genero = data.genero;
    // v.telefono = data.telefono;
    // v.grado_instruccion = data.grado_instruccion;
    // v.idioma = data.idioma_primario;
    // v.idioma1 = data.idioma_secundario;
    // v.oficio_profesion = data.oficio_profesion_primaria;
    // v.religion = data.religion;
    // v.id_etnica = data.identidad_etnica;
    // v.estado_civil = data.estado_civil;
    // v.id_sexual = data.orientacion_sexual;
    // v.numeroFile = data.file_caso;
    // v.jurisdiccion = data.jurisdiccion_caso;
    // v.juez = data.juez_caso;
    // v.juzgado = data.juzgado_caso;
    // v.centro_penitenciario = data.id_centro;
    // v.descripcion_codigo = data.descripcion_codigo;
    // v.codigo = data.codigo;
    // v.situacion_juridica = data.situacion_legal;
    // v.delito = delito.delito;
    // v.anios_sentencia = data.anios_sentencia;
    // v.meses_sentencia = data.meses_sentencia;
    // v.fechaIngreso = data.fecha_ingreso_centro;
    // v.observaciones = data.observacion;
    // v.enfermedad = data.enfermedad;
    // v.enfermedad1 = data.enfermedad1;
    // v.descripcionMedicacion = data.medicacion;
    // v.descripcionMedicacion1 = data.medicacion1;
    // v.obsEnfermedades = data.obsenfermedad;
    // v.nombreFamiliar = data.nombre_completo_familiar;
    // v.parentesco = data.parentesco_familiar;
    // v.telefonoFamiliar = data.telefono_familiar;
    // v.nombreFamiliar1 = data.nombre_completo_familiar1;
    // v.parentesco1 = data.parentesco_familiar1;
    // v.telefonoFamiliar1 = data.telefono_familiar1;
    // haveData.value = true;
    // age(new Date(formData.value.fechaNacimiento));
    onMounted(() => {
      _stepperObj.value = StepperComponent.createInsance(
        createAccountRef.value as HTMLElement
      );
      nameCenters();
      nameDepartament();
      nameCrime();
    });
    // onUpdated(() => {
    //   console.log(dataToEdit.value);
    // });
    const createAppSchema = [];

    // extracts the individual step schema
    const currentSchema = computed(() => {
      return createAppSchema[currentStepIndex.value];
    });

    const totalSteps = computed(() => {
      if (!_stepperObj.value) {
        return;
      }

      return _stepperObj.value.totatStepsNumber;
    });

    const { resetForm, handleSubmit } = useForm<Step1 | Step2 | Step3 | Step4>({
      validationSchema: currentSchema,
    });

    const previousStep = () => {
      if (!_stepperObj.value) {
        return;
      }

      currentStepIndex.value--;

      _stepperObj.value.goPrev();
    };

    const handleStep = handleSubmit((values) => {
      for (const item in values) {
        // eslint-disable-next-line no-prototype-builtins
        if (values.hasOwnProperty(item)) {
          if (values[item]) {
            formData.value[item] = values[item];
          }
        }
      }

      currentStepIndex.value++;

      if (!_stepperObj.value) {
        return;
      }

      _stepperObj.value.goNext();
    });

    const formSubmit = async () => {
      const { data } = await sendForm(formData.value);
      if (data.ok) {
        Swal.fire({
          title: "Registrado",
          text: "La persona Privada de libertad fue registrada exitosamente.",
          icon: "success",
          buttonsStyling: false,
          confirmButtonText: "Continuar",
          customClass: {
            confirmButton: "btn fw-bold btn-light-primary",
          },
        });
        hideModal(createAccountModalRef.value);
        resetformData();
        router.push({ name: "listDeprivedLiberty" });
      } else {
        Swal.fire({
          title: "Error",
          text: "LA filiación no pudo realizarse.",
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: "Continuar",
          customClass: {
            confirmButton: "btn fw-bold btn-light-primary",
          },
        });
      }
      hideModal(createAccountModalRef.value);
      resetformData();
      router.push({ name: "listDeprivedLiberty" });
    };

    resetForm({
      values: {
        ...formData.value,
      },
    });
    const Toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 4000,
      timerProgressBar: true,
    });
    return {
      createAccountRef,
      totalSteps,
      previousStep,
      handleStep,
      formSubmit,
      currentStepIndex,
      formData,
      createAccountModalRef,
      isLoading,
      haveData,
      actualYear,
      actualAge,
      format,
      age,
      resetformData,
      countries,
      languages,
      jobs,
      original_identity,
      nameCenters,
      nameDepartament,
      nameProvince,
      nameMunicipality,
      nameCrime,
      centersList,
      departamentsList,
      provincesList,
      municipalitiesList,
      crimesList,
      clearData: async function () {
        resetformData();
        await resetStatus();
      },
      searchSigep: async () => {
        const { data } = await searchSegip(formData.value);
        if (data.NumeroDocumento == undefined) {
          Toast.fire({
            icon: "error",
            title: "No se encontraron coincidencias.",
          });
          haveData.value = false;
          isLoading.value = false;
          resetformData();
        } else {
          Toast.fire({
            icon: "success",
            title: "Resultado obtenido satistactoriamente.",
          });
          formData.value.numero_doc = data.NumeroDocumento;
          formData.value.complemento =
            data.ComplementoVisible !== "0" &&
            data.ComplementoVisible !== undefined
              ? data.ComplementoVisible
              : "";
          formData.value.nombres = data.Nombres;
          formData.value.primerApellido = data.PrimerApellido;
          formData.value.segundoApellido = data.SegundoApellido;
          formData.value.fechaNacimiento = birthDate(data.FechaNacimiento);
          formData.value.lugarNacimientoPais = data.LugarNacimientoPais;
          // eslint-disable-next-line prettier/prettier
        formData.value.lugarNacimientoDepartamento = data.LugarNacimientoDepartamento;
          formData.value.lugarNacimientoProvincia =
            data.LugarNacimientoProvincia;
          formData.value.lugarNacimientoLocalidad =
            data.LugarNacimientoLocalidad;
          formData.value.fotografia =
            data.Fotografia !== undefined
              ? "data:image/jpeg;base64," + data.Fotografia
              : personImg;
          formData.value.domicilio = data.Domicilio;
          formData.value.genero = data.Genero;
          isLoading.value = false;
          haveData.value = true;
          age(new Date(formData.value.fechaNacimiento));
        }
      },
      dataToEdit,
    };
  },
});
